<template>
  <div class="edu_pages">
    <div class="edu_pages_content_box">
      <div class="edu_page_title_box">
        <div class="title_box">
          <div class="color_lump_box"></div>
          <span>巡查</span>
        </div>
        <div class="edu_operation_box">
          <!-- <sub-organization @getList="getList"></sub-organization> -->
          <el-select v-model="reqData.type" placeholder="请选择" size="mini" style="width:200px;margin-left:5px">
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-date-picker
            v-model="ymy"
            type="year"
            placeholder="选择年"
            size="mini"
            value-format="yyyy"
            v-if="reqData.type == 2"
            style="width:200px;margin-left:5px"
            @change="selYearMonth">
          </el-date-picker>
          <el-date-picker
            v-model="ymm"
            type="month"
            placeholder="选择月"
            size="mini"
            value-format="yyyy-MM"
            v-if="reqData.type == 3"
            style="width:200px;margin-left:5px"
            @change="selYearMonth">
          </el-date-picker>
          <div
            class="search_icon_box button-box"
            @click="searchData()"
          >
            <div></div>
            <span>搜索</span>
          </div>
          <div class="export_icon_box button-box" @click="exportData()">
            <div></div>
            <span>导出</span>
          </div>
        </div>
      </div>
      <sub-organization @getList="getList"></sub-organization>
      
      <div class="edu_pages_content_body_box">
        <div class="edu_table_box rules_table_box">
          <el-table
            v-loading="isLoading"
            :data="resData.list"
            height="100%"
            border
            :header-cell-style="{ background: '#DDE4FF', color: '#474859' }"
            class="table_box"
          >
            <el-table-column
              label="学校"
              align="center"
              prop="schoolName"
            ></el-table-column>
            <el-table-column label="任务总数" align="center">
              <template v-slot="scope">
                {{
                  scope.row.notInspected +
                    scope.row.inspected +
                    scope.row.expired
                }}
              </template>
            </el-table-column>
            <el-table-column
              label="未完成"
              align="center"
              prop="notInspected"
            ></el-table-column>
            <el-table-column
              label="已完成"
              align="center"
              prop="inspected"
            ></el-table-column>
            <el-table-column
              label="已过期"
              align="center"
              prop="expired"
            ></el-table-column>
            <el-table-column label="完成率" align="center" prop="processed">
              <template v-slot="scope">
                {{
                  (scope.row.notInspected + scope.row.inspected + scope.row.expired) == 0
                    ? 0
                    : parseFloat(
                        (
                          (scope.row.inspected * 100) /
                          (scope.row.notInspected +
                            scope.row.inspected +
                            scope.row.expired)
                        ).toFixed(2)
                      )
                }}%
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="edu_pagination_box" v-if="resData.total > 0">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="resData.pageNum"
            :page-size="resData.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="resData.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import subOrganization from "../../components/subOrganizationNew";
import subOrganization from "../../components/subOrganization";
export default {
  name: "patrolExport",
  components: {
    subOrganization
  },
  data() {
    return {
      isLoading: false,
      reqData: {
        eduId: "",
        type: 1,
        ym: "",
        pageNum: 1,
        pageSize: 15
      },
      typeList: [
        {
          value: 1,
          label: '全部'
        }, {
          value: 2,
          label: '查询某一年'
        }, {
          value: 3,
          label: '查询某一月'
        }
      ],
      ymy: "",
      ymm: "",
      resData: {
        list: [],
        total: 0
      }
    };
  },
  computed: {
    eduInfo() {
      return JSON.parse(sessionStorage.getItem("eduInfo"));
    }
  },
  mounted() {
    // this.getDataList();
  },
  methods: {
    handleCurrentChange(val) {
      this.reqData.pageNum = val;
      // console.log(`当前页: ${val}`);
      this.getDataList();
    },
    selYear() {
      this.reqData.ym = this.ymy;
    },
    selYearMonth() {
      this.reqData.ym = this.ymm;
    },
    searchData() {
      let type = this.reqData.type;
      switch (type){
        case 1:
          this.reqData.ym = 1;
          break;
        case 2:
          if(this.ymy == "") {
            this.$message("请选择年份");
          } else {
            this.reqData.ym = this.ymy;
          }
          break;
        case 3:
        if(this.ymm == "") {
            this.$message("请选择月份");
          } else {
            this.reqData.ym = this.ymm;
          }
          break;
        default:
          break;
      }
      this.reqData.pageNum = 1;
      this.getDataList();
    },
    getList(eduId){
      // console.log(eduId, "=========")
      this.reqData.eduId = eduId;
      this.reqData.pageNum = 1;
      this.getDataList();
    },
    async getDataList() {
      // this.reqData.eduId = this.eduInfo.eduId;
      // this.reqData.type = this.eduInfo.eduBuresuType;
      let req = this.reqData;
      this.isLoading = true;
      let res = await this.$Http.getSafePatrolListNew(req);
      this.isLoading = false;
      if (res.code == 200) {
        this.resData = res.data;
      } else if (res.code == 101) {
        this.resData = {
          list: [],
          total: 0
        };
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 导出数据
    async exportData() {
      let req = {
        eduId: Number(this.reqData.eduId)
      };
      this.$Common.exportData(req, "exportSafePatrol", "巡查数据");
    }
  }
};
</script>
<style scoped lang="scss">
@import "../../../../../public/css/edu_pages.scss";
.table-bordered {
  width: 100%;
  height: 100%;
}
.table-thead {
  display: table;
  width: 90%;
  margin: 0px 5%;
  height: 50px;
  background: #dde4ff;
  color: #474859;
  th {
    text-align: center;
    &:nth-child(1) {
      width: 10%;
    }
    &:nth-child(2) {
      width: 20%;
    }
    &:nth-child(3) {
      width: 20%;
    }
    &:nth-child(4) {
      width: 40%;
    }
    &:nth-child(5) {
      width: 10%;
    }
  }
}
.table-tbody {
  display: block;
  height: calc(100% - 50px);
  width: 90%;
  margin: 0px 5%;
  overflow-y: scroll;
  td {
    text-align: center;
    vertical-align: middle;
    &:nth-child(1) {
      width: 10%;
    }
    &:nth-child(2) {
      width: 20%;
    }
    &:nth-child(3) {
      width: 20%;
    }
    &:nth-child(4) {
      width: 40%;
    }
    &:nth-child(5) {
      width: 10%;
    }
  }
}
.bottom-box {
  display: flex;
  justify-content: center;
  align-items: center;
}
.rules_table_box /deep/ .el-table tbody tr:hover > td {
  background-color: #ffffff !important;
}
</style>
